export default "__VITE_ASSET__Divdkb23__"